import React, { FC, useCallback, useState } from 'react'
import './LandingFilter.scss'
import InputComponent from 'app_components/commons/Input/InputComponent'
import { IoIosSearch } from 'react-icons/io'
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import { OverlayTrigger } from 'react-bootstrap'
import LandingFilterOverlay from './components/LandingFilterOverlay/LandingFilterOverlay'
import queryString from 'querystring'
import { useHistory } from 'react-router-dom'
import { routingService } from 'app_services/routingService'
import FilterCourseCharacteristics, { IFilterOnChangeParams } from 'app_components/screens/landing/AcademicFilterScreen/components/FilterCourseCharacteristics/FilterCourseCharacteristics'
import { IoClose } from 'react-icons/io5'
import useWindowWidth from 'app_hooks/useWindowWidth'

const MOVIL_BREAKPOINT = 800

interface ILandingFilterProps {

}

const LandingFilter: FC<ILandingFilterProps> = () => {
  const [showFilter, setShowFilter] = useState<boolean>(false)
  const [showFilterMovil, setShowFilterMovil] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [filterState, setFilterState] = useState<IFilterOnChangeParams>({})
  const { windowWidth } = useWindowWidth()
  const history = useHistory()

  const isMovil = windowWidth && windowWidth <= MOVIL_BREAKPOINT

  const handleClickShowMenu = () => {
    setShowFilter(!showFilter)
  }

  const handleSearch = useCallback(() => {
    const urlParams = queryString.stringify({
      search: searchTerm,
      ...filterState
    })
    history.push(routingService.getPublicPath(`/academic-filter?${urlParams}`))
  }, [filterState, history, searchTerm])

  const handleChangeFilter = useCallback((params: IFilterOnChangeParams) => {
    setFilterState(params)
  }, [])

  const handleClarFilter = () => {
    setSearchTerm('')
    setFilterState({})
  }

  const handleShowFilterMovil = () => {
    setShowFilterMovil(true);
  }

  const handleHideFilterMovil = () => {
    setShowFilterMovil(false);
  }


  return (
    <div className="landing-filter--layout">
      <h1>
        Escuela internacional de formación ICONTEC
      </h1>
      {!isMovil && (
        <h2>Aquí encontrarás programas, cursos y diplomados para convertirte en experto en calidad, sistemas de gestión, sostenibilidad, competitividad y buenas prácticas sectoriales.</h2>
      )}
      <OverlayTrigger
        overlay={(
          <div>
            <LandingFilterOverlay onChange={handleChangeFilter} onClear={handleClarFilter} onFilter={handleSearch} />
          </div>
        )}
        placement='bottom-start'
        trigger={['click']}
        onToggle={isMovil ? handleShowFilterMovil : handleClickShowMenu}
        show={showFilter}
      >
        {({ ref, ...triggerHandler }) => (
          <div className='landing-filter--input-container' ref={ref}>
            <div className='landing-filter--input-select' onClick={isMovil ? handleShowFilterMovil : handleClickShowMenu} {...triggerHandler}>
              Todas las categorías
              <MdOutlineKeyboardArrowDown />
            </div>
            <InputComponent
              placeholder='Quiero aprender sobre...'
              className='landing-filter--input-text'
              endIcon={<IoIosSearch onClick={handleSearch} cursor='pointer' />}
              value={searchTerm}
              onChange={({ target: { value } }) => setSearchTerm(value)}
              onEnter={handleSearch}
            />
          </div>
        )}
      </OverlayTrigger>
      <div className={'landing-filter--movil-filter-container ' + (showFilterMovil ? '' : 'close')}>
        <IoClose size={23} color='var(--secondary)' cursor={'pointer'} onClick={handleHideFilterMovil}/>
        <FilterCourseCharacteristics
          updateSearchParams={false}
          onChange={handleChangeFilter}
          onFilter={handleSearch}
        />
      </div>
    </div>
  )
}

export default LandingFilter
